module.exports = __webpack_public_path__ + "img/02d.9f703526.svg";